import React from "react";
// import '../Menu2.css';
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const ProblemStatement = () => {
	return (
		<>
			<Navbar />
			<div>
				<Homecarousel />
			</div>
			<div
				style={{ padding: "5px 15px", maxWidth: "1330px", margin: "0 auto" }}>
				<div className="content-container" style={{ marginBottom: "3rem" }}>
					<div style={{ marginBottom: "0rem", marginTop: "20px" }}>
						<h2
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "30px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "30px",
							}}>
							Why We Built This Platform
						</h2>
					</div>
					<div className="text-container-2" style={{ width: "100%" }}>
						<span>
							Today’s farmers organisations and SME food businesses face big
							hurdles:
						</span>
						<br />
						<br />
						<ul
							style={{
								margin: "0px",
								padding: "0px",
								display: "flex",
								flexDirection: "column",
								gap: "10px",
							}}>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										Complex certification and audit processes
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										Limited access to reliable, hands-on guidance
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">Low digital adoption</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										Shortage of skilled compliance professionals
									</span>
								</div>
							</li>
						</ul>
						<br />
						Meanwhile, standard owners and certifiers can’t offer direct
						implementation help — leaving a huge gap. That’s where we come in.
						The Global Academy bridges this gap with independent, expert-led,
						and tech-enabled support — so you’re not just certified, you’re
						market-ready, profitable, and future-proof.
					</div>
				</div>
				<div className="content-container">
					<div style={{ marginBottom: "0rem", marginTop: "20px" }}>
						<h2
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "30px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "30px",
							}}>
							Ready to get started?
						</h2>
					</div>
					<div className="text-container" style={{ width: "100%" }}>
						<span>
							Join the movement to elevate India’s food sector — where safe,
							sustainable, and globally certified food is the norm, not the
							exception.
						</span>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ProblemStatement;
